import { css } from '@emotion/core'
import { measures } from 'styles/variables'
import * as MQ from 'styles/media-queries'

const { unit } = measures

export const select = {
  control: (state) => {
    if (state.isDisabled) {
      return { backgroundColor: 'transparent' }
    }
  },

  indicatorsContainer: (state) => {
    if (state.isDisabled) {
      return { display: 'none' }
    }
  },
}

export const control = css`
  &:disabled {
    background-color: transparent;
  }
`

export const row = css`
  display: flex;
  align-items: center;
  min-height: ${8 * unit}px;
  ${MQ.PHONES} {
    justify-content: space-between;
  }
  ${MQ.NOT_PHONES} {
    & label {
      min-width: ${16 * unit}px;
      margin-bottom: ${2 * unit}px;
    }
  }
`

export const controlsWrapper = css`
  text-align: left;
`
